import React from 'react';
import { TableFieldType, convertValueToFieldType } from "../../../../data/TableFieldType";
import DateTime from "../DateTime/DateTime";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function TableFieldTypeColumn(props) {
    var contents = props.value;
    switch (props.type) {
        case TableFieldType.tdt_s:
            contents = React.createElement(DateTime, { date: convertValueToFieldType(props.value, props.type), compact: true });
            break;
        case TableFieldType.f:
        case TableFieldType.i:
            contents = convertValueToFieldType(props.value, props.type);
            if (isNaN(contents)) {
                contents = '-';
            }
            break;
        case TableFieldType.s:
            contents = convertValueToFieldType(props.value, props.type);
            if (contents === null || contents === undefined) {
                contents = '-';
            }
            break;
    }
    return React.createElement("td", { className: "text-nowrap" }, contents);
}
TableFieldTypeColumn.defaultProps = {};
